// @generated by protoc-gen-es v2.10.1 with parameter "target=ts"
// @generated from file bffuser/v1/global_alert_service.proto (package bffuser.v1, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage, GenService } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc, serviceDesc } from "@bufbuild/protobuf/codegenv2";
import type { AutoBidNotOrderedNotice } from "./auto_bid_notice_model_pb";
import { file_bffuser_v1_auto_bid_notice_model } from "./auto_bid_notice_model_pb";
import type { BiddingBidMarket } from "./bidding_common_model_pb";
import { file_bffuser_v1_bidding_common_model } from "./bidding_common_model_pb";
import type { OcctoCredentialAlert } from "./global_alert_model_pb";
import { file_bffuser_v1_global_alert_model } from "./global_alert_model_pb";
import type { MissedDeadlinePlanNotice, UnsubmittedPlanNotice } from "./plan_auto_submit_notice_model_pb";
import { file_bffuser_v1_plan_auto_submit_notice_model } from "./plan_auto_submit_notice_model_pb";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file bffuser/v1/global_alert_service.proto.
 */
export const file_bffuser_v1_global_alert_service: GenFile = /*@__PURE__*/
  fileDesc("CiViZmZ1c2VyL3YxL2dsb2JhbF9hbGVydF9zZXJ2aWNlLnByb3RvEgpiZmZ1c2VyLnYxIiIKIExpc3RPY2N0b0NyZWRlbnRpYWxBbGVydHNSZXF1ZXN0IlUKIUxpc3RPY2N0b0NyZWRlbnRpYWxBbGVydHNSZXNwb25zZRIwCgZhbGVydHMYASADKAsyIC5iZmZ1c2VyLnYxLk9jY3RvQ3JlZGVudGlhbEFsZXJ0IiUKI0xpc3RBdXRvQmlkTm90T3JkZXJlZE5vdGljZXNSZXF1ZXN0IlwKJExpc3RBdXRvQmlkTm90T3JkZXJlZE5vdGljZXNSZXNwb25zZRI0Cgdub3RpY2VzGAEgAygLMiMuYmZmdXNlci52MS5BdXRvQmlkTm90T3JkZXJlZE5vdGljZSIkCiJMaXN0VW5rbm93bklzc3VlckJpZE1hcmtldHNSZXF1ZXN0IlQKI0xpc3RVbmtub3duSXNzdWVyQmlkTWFya2V0c1Jlc3BvbnNlEi0KB21hcmtldHMYASADKA4yHC5iZmZ1c2VyLnYxLkJpZGRpbmdCaWRNYXJrZXQiIgogTGlzdFBsYW5BdXRvU3VibWl0Tm90aWNlc1JlcXVlc3QipgEKIUxpc3RQbGFuQXV0b1N1Ym1pdE5vdGljZXNSZXNwb25zZRI8ChF1bnN1Ym1pdHRlZF9wbGFucxgBIAMoCzIhLmJmZnVzZXIudjEuVW5zdWJtaXR0ZWRQbGFuTm90aWNlEkMKFW1pc3NlZF9kZWFkbGluZV9wbGFucxgCIAMoCzIkLmJmZnVzZXIudjEuTWlzc2VkRGVhZGxpbmVQbGFuTm90aWNlMowEChJHbG9iYWxBbGVydFNlcnZpY2USeAoZTGlzdE9jY3RvQ3JlZGVudGlhbEFsZXJ0cxIsLmJmZnVzZXIudjEuTGlzdE9jY3RvQ3JlZGVudGlhbEFsZXJ0c1JlcXVlc3QaLS5iZmZ1c2VyLnYxLkxpc3RPY2N0b0NyZWRlbnRpYWxBbGVydHNSZXNwb25zZRKBAQocTGlzdEF1dG9CaWROb3RPcmRlcmVkTm90aWNlcxIvLmJmZnVzZXIudjEuTGlzdEF1dG9CaWROb3RPcmRlcmVkTm90aWNlc1JlcXVlc3QaMC5iZmZ1c2VyLnYxLkxpc3RBdXRvQmlkTm90T3JkZXJlZE5vdGljZXNSZXNwb25zZRJ+ChtMaXN0VW5rbm93bklzc3VlckJpZE1hcmtldHMSLi5iZmZ1c2VyLnYxLkxpc3RVbmtub3duSXNzdWVyQmlkTWFya2V0c1JlcXVlc3QaLy5iZmZ1c2VyLnYxLkxpc3RVbmtub3duSXNzdWVyQmlkTWFya2V0c1Jlc3BvbnNlEngKGUxpc3RQbGFuQXV0b1N1Ym1pdE5vdGljZXMSLC5iZmZ1c2VyLnYxLkxpc3RQbGFuQXV0b1N1Ym1pdE5vdGljZXNSZXF1ZXN0Gi0uYmZmdXNlci52MS5MaXN0UGxhbkF1dG9TdWJtaXROb3RpY2VzUmVzcG9uc2VCQFo+Z2l0aHViLmNvbS9lbmVjaGFpbi9lYmFsYW5jZS9nby9nZW4vcHJvdG8vYmZmdXNlci92MTtiZmZ1c2VydjFiBnByb3RvMw", [file_bffuser_v1_auto_bid_notice_model, file_bffuser_v1_bidding_common_model, file_bffuser_v1_global_alert_model, file_bffuser_v1_plan_auto_submit_notice_model]);

/**
 * @generated from message bffuser.v1.ListOcctoCredentialAlertsRequest
 */
export type ListOcctoCredentialAlertsRequest = Message<"bffuser.v1.ListOcctoCredentialAlertsRequest"> & {
};

/**
 * Describes the message bffuser.v1.ListOcctoCredentialAlertsRequest.
 * Use `create(ListOcctoCredentialAlertsRequestSchema)` to create a new message.
 */
export const ListOcctoCredentialAlertsRequestSchema: GenMessage<ListOcctoCredentialAlertsRequest> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_global_alert_service, 0);

/**
 * @generated from message bffuser.v1.ListOcctoCredentialAlertsResponse
 */
export type ListOcctoCredentialAlertsResponse = Message<"bffuser.v1.ListOcctoCredentialAlertsResponse"> & {
  /**
   * Business codes currently under the warning, ascending.
   *
   * @generated from field: repeated bffuser.v1.OcctoCredentialAlert alerts = 1;
   */
  alerts: OcctoCredentialAlert[];
};

/**
 * Describes the message bffuser.v1.ListOcctoCredentialAlertsResponse.
 * Use `create(ListOcctoCredentialAlertsResponseSchema)` to create a new message.
 */
export const ListOcctoCredentialAlertsResponseSchema: GenMessage<ListOcctoCredentialAlertsResponse> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_global_alert_service, 1);

/**
 * @generated from message bffuser.v1.ListAutoBidNotOrderedNoticesRequest
 */
export type ListAutoBidNotOrderedNoticesRequest = Message<"bffuser.v1.ListAutoBidNotOrderedNoticesRequest"> & {
};

/**
 * Describes the message bffuser.v1.ListAutoBidNotOrderedNoticesRequest.
 * Use `create(ListAutoBidNotOrderedNoticesRequestSchema)` to create a new message.
 */
export const ListAutoBidNotOrderedNoticesRequestSchema: GenMessage<ListAutoBidNotOrderedNoticesRequest> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_global_alert_service, 2);

/**
 * @generated from message bffuser.v1.ListAutoBidNotOrderedNoticesResponse
 */
export type ListAutoBidNotOrderedNoticesResponse = Message<"bffuser.v1.ListAutoBidNotOrderedNoticesResponse"> & {
  /**
   * Ordered by market; within a market, records whose bidding deadline has not
   * passed come before those whose deadline has passed; each group by delivery
   * date, koma, area, issuer type, side, reason. The banner shows the records
   * in this order without re-sorting.
   *
   * @generated from field: repeated bffuser.v1.AutoBidNotOrderedNotice notices = 1;
   */
  notices: AutoBidNotOrderedNotice[];
};

/**
 * Describes the message bffuser.v1.ListAutoBidNotOrderedNoticesResponse.
 * Use `create(ListAutoBidNotOrderedNoticesResponseSchema)` to create a new message.
 */
export const ListAutoBidNotOrderedNoticesResponseSchema: GenMessage<ListAutoBidNotOrderedNoticesResponse> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_global_alert_service, 3);

/**
 * @generated from message bffuser.v1.ListUnknownIssuerBidMarketsRequest
 */
export type ListUnknownIssuerBidMarketsRequest = Message<"bffuser.v1.ListUnknownIssuerBidMarketsRequest"> & {
};

/**
 * Describes the message bffuser.v1.ListUnknownIssuerBidMarketsRequest.
 * Use `create(ListUnknownIssuerBidMarketsRequestSchema)` to create a new message.
 */
export const ListUnknownIssuerBidMarketsRequestSchema: GenMessage<ListUnknownIssuerBidMarketsRequest> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_global_alert_service, 4);

/**
 * @generated from message bffuser.v1.ListUnknownIssuerBidMarketsResponse
 */
export type ListUnknownIssuerBidMarketsResponse = Message<"bffuser.v1.ListUnknownIssuerBidMarketsResponse"> & {
  /**
   * Markets with such a bid, ascending. Mirrors internalapi.v1.BidMarket.
   *
   * @generated from field: repeated bffuser.v1.BiddingBidMarket markets = 1;
   */
  markets: BiddingBidMarket[];
};

/**
 * Describes the message bffuser.v1.ListUnknownIssuerBidMarketsResponse.
 * Use `create(ListUnknownIssuerBidMarketsResponseSchema)` to create a new message.
 */
export const ListUnknownIssuerBidMarketsResponseSchema: GenMessage<ListUnknownIssuerBidMarketsResponse> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_global_alert_service, 5);

/**
 * @generated from message bffuser.v1.ListPlanAutoSubmitNoticesRequest
 */
export type ListPlanAutoSubmitNoticesRequest = Message<"bffuser.v1.ListPlanAutoSubmitNoticesRequest"> & {
};

/**
 * Describes the message bffuser.v1.ListPlanAutoSubmitNoticesRequest.
 * Use `create(ListPlanAutoSubmitNoticesRequestSchema)` to create a new message.
 */
export const ListPlanAutoSubmitNoticesRequestSchema: GenMessage<ListPlanAutoSubmitNoticesRequest> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_global_alert_service, 6);

/**
 * @generated from message bffuser.v1.ListPlanAutoSubmitNoticesResponse
 */
export type ListPlanAutoSubmitNoticesResponse = Message<"bffuser.v1.ListPlanAutoSubmitNoticesResponse"> & {
  /**
   * 自動で提出できていない計画. Ordered by target date, timeframe, area,
   * submission entity code, kind; the banner shows them without re-sorting.
   *
   * @generated from field: repeated bffuser.v1.UnsubmittedPlanNotice unsubmitted_plans = 1;
   */
  unsubmittedPlans: UnsubmittedPlanNotice[];

  /**
   * 締切までに出し直せなかった計画, in the same order.
   *
   * @generated from field: repeated bffuser.v1.MissedDeadlinePlanNotice missed_deadline_plans = 2;
   */
  missedDeadlinePlans: MissedDeadlinePlanNotice[];
};

/**
 * Describes the message bffuser.v1.ListPlanAutoSubmitNoticesResponse.
 * Use `create(ListPlanAutoSubmitNoticesResponseSchema)` to create a new message.
 */
export const ListPlanAutoSubmitNoticesResponseSchema: GenMessage<ListPlanAutoSubmitNoticesResponse> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_global_alert_service, 7);

/**
 * GlobalAlertService serves the warnings every screen shows in the common
 * TickerBar (全画面共通の警告枠).
 *
 * @generated from service bffuser.v1.GlobalAlertService
 */
export const GlobalAlertService: GenService<{
  /**
   * ListOcctoCredentialAlerts returns the OCCTO 事業者コード of the session's
   * organization currently under the 認証情報不備 warning (spec
   * plan-common.md AC-PLC-053), ordered by business code ascending; empty
   * when none.
   *
   * @generated from rpc bffuser.v1.GlobalAlertService.ListOcctoCredentialAlerts
   */
  listOcctoCredentialAlerts: {
    methodKind: "unary";
    input: typeof ListOcctoCredentialAlertsRequestSchema;
    output: typeof ListOcctoCredentialAlertsResponseSchema;
  },
  /**
   * ListAutoBidNotOrderedNotices returns the 自動入札が発注しなかったコマ
   * records of the session's organization that are within the display period
   * and not yet resolved (spec approval-flow.md AC-APF-069, shared-components.md
   * AC-SC-041). The side menu dots and the bidding-screen banners share this
   * result; not filtered by the caller's permissions. Empty when none.
   *
   * @generated from rpc bffuser.v1.GlobalAlertService.ListAutoBidNotOrderedNotices
   */
  listAutoBidNotOrderedNotices: {
    methodKind: "unary";
    input: typeof ListAutoBidNotOrderedNoticesRequestSchema;
    output: typeof ListAutoBidNotOrderedNoticesResponseSchema;
  },
  /**
   * ListUnknownIssuerBidMarkets returns the markets in which the session's
   * organization has a bid placed outside eBalance whose 発注主体区分 is blank
   * (its 受渡契約コード is not in the 広域マスタ) and whose 受渡日 is today (JST)
   * or later (spec shared-components.md AC-SC-043, spot-bidding.md AC-BSP-111b,
   * intraday-bidding.md AC-BIN-109a). The side menu dots use it; the same result
   * for every user of the organization. Empty when none.
   *
   * @generated from rpc bffuser.v1.GlobalAlertService.ListUnknownIssuerBidMarkets
   */
  listUnknownIssuerBidMarkets: {
    methodKind: "unary";
    input: typeof ListUnknownIssuerBidMarketsRequestSchema;
    output: typeof ListUnknownIssuerBidMarketsResponseSchema;
  },
  /**
   * ListPlanAutoSubmitNotices returns the plans of the session's organization
   * that 計画の自動提出 / 計画の自動再提出 could not submit or resubmit, announced
   * now (spec workflow-templates.md AC-WFT-045, plan-auto-resubmit.md AC-PAR-004
   * / 006 / 009, procurement-plan-list.md AC-PPL-035). The side menu dots and
   * the plan-list banners share this result; not filtered by the caller's
   * permissions (AC-SC-042). Empty when none.
   *
   * @generated from rpc bffuser.v1.GlobalAlertService.ListPlanAutoSubmitNotices
   */
  listPlanAutoSubmitNotices: {
    methodKind: "unary";
    input: typeof ListPlanAutoSubmitNoticesRequestSchema;
    output: typeof ListPlanAutoSubmitNoticesResponseSchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_bffuser_v1_global_alert_service, 0);

